<div class="stable-height background">
  <div class="container d-flex flex-md-row flex-column">
    <div class="col text-background p-4 content-container">
      <div class="row mb-4 mb-sm-2 mt-4">
        <div class="col-12 d-inline-block d-flex flex-column choose-plan-title-wrapper">
          <h2 class="title">Recommended by pet owners across the UK</h2>
        </div>
      </div>
    </div>
    <div class="image-container">
      <img
        src="/assets/images/home/testimonials.png"
        alt="carousel slide 2"
        class="slide-image"
      />
    </div>
  </div>
</div>
